const t=t=>{const c=[...t];return c.splice(-1,1),c};export{t as getArrayWithoutLastElement};
